import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, RefreshCwIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
const STACK = [{
  label: "📘 Colección Protocolo Clínica Segura™ (6 Tomos Premium)",
  value: "USD $97"
}, {
  label: "🎁 5 Bonos Exclusivos",
  value: "USD $197"
}];
export function Offer() {
  return <section id="oferta" className="w-full bg-[var(--brand)] px-4 py-14" data-id="element-155" data-mp="tzd9uv7ybygq">
      <div className="mx-auto max-w-lg" data-id="element-156" data-mp="p0jx550hobhm">
        <div className="text-center" data-id="element-157" data-mp="p1uyky6gp75k">
          <div className="mx-auto mb-3 inline-flex items-center gap-1.5 rounded-full bg-white/15 px-4 py-1.5 text-xs font-bold uppercase text-white" data-id="element-158" data-mp="13xkce91hudz7">
            🏆 Oferta especial de lanzamiento
          </div>
          <h2 className="font-serif-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-159" data-mp="2fbeqwlknxdct">
            Esto es todo lo que recibirás hoy
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-160" data-mp="pk7gpnxeupai">
          <div className="divide-y divide-gray-100 p-5" data-id="element-161" data-mp="zi5283nvy7zf">
            {STACK.map(s => <div key={s.label} className="flex items-start justify-between gap-3 py-3" data-id="element-162" data-mp="13ki60mj2nvtk">
                <span className="text-sm font-medium text-gray-700" data-id="element-163" data-mp="6tzhvi0qul04">{s.label}</span>
                <span className="shrink-0 text-sm font-bold text-gray-400 line-through" data-id="element-164" data-mp="bstyqef5hzhl">{s.value}</span>
              </div>)}
            <div className="flex items-center justify-between gap-3 py-3" data-id="element-165" data-mp="ftcswf4inhmy">
              <span className="text-sm font-extrabold uppercase text-gray-900" data-id="element-166" data-mp="kkvyeahebbqt">Valor total</span>
              <span className="text-lg font-extrabold text-gray-400 line-through" data-id="element-167" data-mp="3k8vqkgpyi87q">USD $294</span>
            </div>
          </div>

          <div className="bg-[var(--cream)] px-5 py-7 text-center" data-id="element-168" data-mp="3o95zo291peqt">
            <p className="text-sm font-medium text-gray-500" data-id="element-169" data-mp="vfh6aca5d1lg">Hoy puedes obtener acceso completo por solo…</p>
            <div className="mt-1 font-serif-display text-5xl font-extrabold text-[var(--brand)] sm:text-6xl" data-id="element-170" data-mp="qh5wg1juqr38">
              USD $15
            </div>
            <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs font-semibold text-gray-600" data-id="element-171" data-mp="154qvnkdlw65v">
              <span className="inline-flex items-center gap-1" data-id="element-172" data-mp="108tj7p5grjyd"><CheckIcon className="h-3.5 w-3.5 text-[var(--cta)]" data-id="element-173" data-mp="chxres10cor4" /> Pago único</span>
              <span className="inline-flex items-center gap-1" data-id="element-174" data-mp="7il82h9chzta"><CheckIcon className="h-3.5 w-3.5 text-[var(--cta)]" data-id="element-175" data-mp="7jwbuh2sj7ke" /> Acceso de por vida</span>
              <span className="inline-flex items-center gap-1" data-id="element-176" data-mp="livwldn6n2ba"><CheckIcon className="h-3.5 w-3.5 text-[var(--cta)]" data-id="element-177" data-mp="hfg4mum25q4x" /> Sin mensualidades</span>
              <span className="inline-flex items-center gap-1" data-id="element-178" data-mp="1ww6t69gpbdav"><CheckIcon className="h-3.5 w-3.5 text-[var(--cta)]" data-id="element-179" data-mp="1wuwsdcigrr0j" /> Descarga inmediata</span>
            </div>

            <p className="mx-auto mt-4 max-w-sm text-xs leading-relaxed text-gray-500" data-id="element-180" data-mp="1sx7evy92y46r">
              Por menos de lo que cuesta una comida, tendrás una biblioteca profesional para
              consultar cada vez que enfrentes un caso complejo.
            </p>

            <div className="mt-6" data-id="element-181" data-mp="1qhj22v7mulfz">
              <CTAButton data-id="element-182" data-mp="1qikizgbby25m" />
              <p className="mt-3 text-xs font-medium text-gray-500" data-id="element-183" data-mp="1vfatzp8a27k6">
                Pago único de <strong data-id="element-184" data-mp="1vhdsyyrerb11">USD $15</strong> · Descarga inmediata · Garantía de 7 días
              </p>
            </div>

            <div className="mt-5 flex items-center justify-center gap-1.5 rounded-lg bg-[var(--brand)]/5 px-3 py-2 text-xs font-medium text-[var(--brand)]" data-id="element-185" data-mp="2o3ylw3nj7v6p">
              <RefreshCwIcon className="h-3.5 w-3.5" data-id="element-186" data-mp="29f26tmn25hwl" />
              El cambio de moneda se realiza automáticamente según tu país.
            </div>

            <div className="mt-6" data-id="element-187" data-mp="323hgrurc1a12">
              <Countdown data-id="element-188" data-mp="322g6vtm1ytkx" />
            </div>

            <div className="mt-6" data-id="element-189" data-mp="36upu31vs9fji">
              <ScarcityBar data-id="element-190" data-mp="36vrdbtmyd8cb" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}